import { PaginatedResponse } from '../../shared/pagination/paginated-response';
import { ApiDisabilityStatus } from '../api-types/disability-status.api';
import { DisabilityStatus } from '../app-types/disability-status.app';

/**
 * Transforms API disability status data to application disability status data.
 * @param input The API disability status data to transform.
 * @returns The transformed application disability status data.
 */
export const transformApiDisabilityStatusToAppDisabilityStatus = (
	input: PaginatedResponse<ApiDisabilityStatus>,
): PaginatedResponse<DisabilityStatus> => {
	return {
		...input,
		entities: input.entities.map((apiStatus) => ({
			id: apiStatus.id,
			remark: apiStatus.remark,
			relatedDisabilitySeverities: apiStatus.relatedDisabilitySeverities?.map((severity) => ({
				id: severity.id,
				remark: severity.remark,
			})),
			initial: apiStatus.initial,
		})),
	};
};
